// Mock career data based on 12th marks and streams
export const careerData = {
  science: {
    high: [
      {
        id: 1,
        name: "Computer Science Engineering",
        description: "Design and develop software applications, systems, and technologies",
        salary: "₹6-15 LPA",
        duration: "4 years",
        topColleges: ["IIT", "NIT", "BITS Pilani", "Delhi University"],
        skills: ["Programming", "Problem Solving", "Mathematics", "Logic"],
        demand: "Very High",
        icon: "💻"
      },
      {
        id: 2,
        name: "Medical (MBBS)",
        description: "Become a doctor and practice medicine",
        salary: "₹8-20 LPA",
        duration: "5.5 years",
        topColleges: ["AIIMS", "JIPMER", "State Medical Colleges"],
        skills: ["Biology", "Chemistry", "Patient Care", "Communication"],
        demand: "Very High",
        icon: "🏥"
      },
      {
        id: 3,
        name: "Data Science",
        description: "Analyze and interpret complex data to help organizations make decisions",
        salary: "₹7-18 LPA",
        duration: "4 years",
        topColleges: ["IIT", "IIIT", "ISI Kolkata", "Delhi University"],
        skills: ["Statistics", "Programming", "Machine Learning", "Analytics"],
        demand: "Very High",
        icon: "📊"
      },
      {
        id: 4,
        name: "Aerospace Engineering",
        description: "Design and develop aircraft, spacecraft, and related systems",
        salary: "₹6-12 LPA",
        duration: "4 years",
        topColleges: ["IIT", "NIT", "IIST", "MIT Manipal"],
        skills: ["Physics", "Mathematics", "Design", "Aerodynamics"],
        demand: "High",
        icon: "✈️"
      }
    ],
    medium: [
      {
        id: 5,
        name: "Biotechnology",
        description: "Apply biological processes to develop products and technologies",
        salary: "₹4-10 LPA",
        duration: "4 years",
        topColleges: ["IIT", "NIT", "Delhi University", "JNU"],
        skills: ["Biology", "Chemistry", "Research", "Laboratory Work"],
        demand: "High",
        icon: "🧬"
      },
      {
        id: 6,
        name: "Pharmacy",
        description: "Study drugs and their effects on the human body",
        salary: "₹3-8 LPA",
        duration: "4 years",
        topColleges: ["NIPER", "JSS", "Manipal", "BITS"],
        skills: ["Chemistry", "Biology", "Drug Knowledge", "Patient Care"],
        demand: "High",
        icon: "💊"
      },
      {
        id: 7,
        name: "Environmental Science",
        description: "Study and solve environmental problems",
        salary: "₹3-7 LPA",
        duration: "3-4 years",
        topColleges: ["Delhi University", "JNU", "TERI", "IISc"],
        skills: ["Biology", "Chemistry", "Environmental Awareness", "Research"],
        demand: "Medium",
        icon: "🌱"
      }
    ],
    low: [
      {
        id: 8,
        name: "Agriculture",
        description: "Study farming techniques and agricultural sciences",
        salary: "₹2-6 LPA",
        duration: "4 years",
        topColleges: ["ICAR", "State Agricultural Universities"],
        skills: ["Biology", "Chemistry", "Farming", "Business"],
        demand: "Medium",
        icon: "🌾"
      },
      {
        id: 9,
        name: "Forestry",
        description: "Manage and conserve forest resources",
        salary: "₹2-5 LPA",
        duration: "4 years",
        topColleges: ["Forest Research Institute", "State Universities"],
        skills: ["Biology", "Environmental Science", "Management", "Field Work"],
        demand: "Low",
        icon: "🌲"
      }
    ]
  },
  commerce: {
    high: [
      {
        id: 10,
        name: "Chartered Accountancy (CA)",
        description: "Professional accounting and financial management",
        salary: "₹6-20 LPA",
        duration: "3-5 years",
        topColleges: ["ICAI", "Self Study"],
        skills: ["Accounting", "Taxation", "Auditing", "Business Law"],
        demand: "Very High",
        icon: "📋"
      },
      {
        id: 11,
        name: "Company Secretary (CS)",
        description: "Corporate governance and compliance management",
        salary: "₹5-15 LPA",
        duration: "3-4 years",
        topColleges: ["ICSI", "Self Study"],
        skills: ["Corporate Law", "Compliance", "Communication", "Management"],
        demand: "High",
        icon: "📄"
      },
      {
        id: 12,
        name: "Investment Banking",
        description: "Financial services and investment management",
        salary: "₹8-25 LPA",
        duration: "3-4 years",
        topColleges: ["IIM", "XLRI", "FMS", "ISB"],
        skills: ["Finance", "Economics", "Analytics", "Communication"],
        demand: "Very High",
        icon: "💰"
      }
    ],
    medium: [
      {
        id: 13,
        name: "Business Administration (BBA)",
        description: "Learn business management and administration",
        salary: "₹3-8 LPA",
        duration: "3 years",
        topColleges: ["Delhi University", "Christ University", "Symbiosis"],
        skills: ["Management", "Marketing", "Finance", "Communication"],
        demand: "High",
        icon: "🏢"
      },
      {
        id: 14,
        name: "Banking & Finance",
        description: "Work in banking sector and financial services",
        salary: "₹3-7 LPA",
        duration: "3-4 years",
        topColleges: ["Delhi University", "Mumbai University", "Pune University"],
        skills: ["Finance", "Economics", "Customer Service", "Analytics"],
        demand: "High",
        icon: "🏦"
      }
    ],
    low: [
      {
        id: 15,
        name: "Retail Management",
        description: "Manage retail operations and customer service",
        salary: "₹2-5 LPA",
        duration: "3 years",
        topColleges: ["Various Universities", "Private Institutes"],
        skills: ["Customer Service", "Sales", "Management", "Communication"],
        demand: "Medium",
        icon: "🛍️"
      }
    ]
  },
  arts: {
    high: [
      {
        id: 16,
        name: "Law (LLB)",
        description: "Study law and become a legal professional",
        salary: "₹4-15 LPA",
        duration: "5 years",
        topColleges: ["NLU", "Delhi University", "Mumbai University"],
        skills: ["Legal Research", "Communication", "Analytical Thinking", "Writing"],
        demand: "High",
        icon: "⚖️"
      },
      {
        id: 17,
        name: "Journalism & Mass Communication",
        description: "Work in media and communication industry",
        salary: "₹3-10 LPA",
        duration: "3 years",
        topColleges: ["Delhi University", "JNU", "XIC", "IIMC"],
        skills: ["Communication", "Writing", "Media", "Creativity"],
        demand: "High",
        icon: "📰"
      },
      {
        id: 18,
        name: "Psychology",
        description: "Study human behavior and mental processes",
        salary: "₹3-8 LPA",
        duration: "3-5 years",
        topColleges: ["Delhi University", "JNU", "TISS", "Christ University"],
        skills: ["Research", "Communication", "Empathy", "Analysis"],
        demand: "High",
        icon: "🧠"
      }
    ],
    medium: [
      {
        id: 19,
        name: "English Literature",
        description: "Study English language and literature",
        salary: "₹2-6 LPA",
        duration: "3 years",
        topColleges: ["Delhi University", "JNU", "Various Universities"],
        skills: ["Writing", "Communication", "Critical Thinking", "Research"],
        demand: "Medium",
        icon: "📚"
      },
      {
        id: 20,
        name: "History",
        description: "Study historical events and their impact",
        salary: "₹2-5 LPA",
        duration: "3 years",
        topColleges: ["Delhi University", "JNU", "Various Universities"],
        skills: ["Research", "Writing", "Analysis", "Critical Thinking"],
        demand: "Low",
        icon: "🏛️"
      }
    ],
    low: [
      {
        id: 21,
        name: "Fine Arts",
        description: "Pursue creative arts and design",
        salary: "₹2-6 LPA",
        duration: "3-4 years",
        topColleges: ["JNU", "Various Art Schools", "Private Institutes"],
        skills: ["Creativity", "Design", "Visual Arts", "Communication"],
        demand: "Low",
        icon: "🎨"
      }
    ]
  }
};

// AI recommendation logic
export const getCareerRecommendations = (stream, marks, interests = []) => {
  let performanceLevel = 'low';
  const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Authorization", "Bearer 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");
myHeaders.append("Cookie", "__cf_bm=XesYoxz379EVGoJUBGctyltRxI0KHI1UIBOiz20gyQ4-1752898571-1.0.1.1-X_QRSQRyz7.qLOZhlN59CbMgAgac6X1nYbuAc4sQhu0FVoGH6PLskwTFP4h47Po.5upDuZ9EzVydNT5mv2ZWsV3wfaUxDjw5mv6Z5c3nsX4; _cfuvid=6PC5Fw6gxvp_XJRx8lB41aCSppDSJZzMX_CjHKD.DTo-1752750749057-0.0.1.1-604800000");

const raw = JSON.stringify({
  "model": "gpt-4o-mini",
  "store": true,
  "messages": [
    {
      "role": "user",
      "content": "Give me top 5 career options for a student with 12th marks 80% in science stream in json"
    }
  ]
});

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch("https://api.openai.com/v1/chat/completions", requestOptions)
  .then((response) => response.text())
  .then((result) => console.log(result))
  .catch((error) => console.error(error));
  if (marks >= 85) {
    performanceLevel = 'high';
  } else if (marks >= 70) {
    performanceLevel = 'medium';
  }
  
  let recommendations = careerData[stream]?.[performanceLevel] || [];
  
  // Add some randomization to simulate AI analysis
  const shuffled = [...recommendations].sort(() => 0.5 - Math.random());
  
  // Return top 3-4 recommendations
  return shuffled.slice(0, Math.min(4, shuffled.length));
};

// Get all available streams
export const getStreams = () => Object.keys(careerData);

// Get performance level based on marks
export const getPerformanceLevel = (marks) => {
  if (marks >= 85) return 'high';
  if (marks >= 70) return 'medium';
  return 'low';
}; 